import React from 'react'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import {useTranslation} from 'next-i18next'

export default function RequiredPill() {
  const {t} = useTranslation('generic')
  const darkMode = useIsDarkMode()
  return (
    <div className="block">
      <div
        className={classnames({
          'px-2 py-1 rounded font-semibold': true,
          'bg-amber-50 text-amber-500': !darkMode,
          'bg-amber-500 text-amber-50': darkMode
        })}>
        {t('fields.required')}
      </div>
    </div>
  )
}
